import { useTranslation } from 'react-i18next';

import { DatePicker } from '@mantine/dates';

import { OutlinedCalendarIcon } from 'assets';
import { SectionContainer } from 'components/shared';
import { DATE_PICKER_DATE_FORMAT } from 'constants/dateFormats';
import { PalletBalance } from 'interfaces';
import { getPalletsAmountLabel } from 'utils/functions';

import RentedPalletsSummarySectionActionsDropdown from './RentedPalletsSummarySectionActionsDropdown/RentedPalletsSummarySectionActionsDropdown';
import styles from './RentedPalletsSummarySection.module.css';

type RentedPalletsSummarySectionProps = {
   rentedPalletsSummaryData: PalletBalance;
   isSupplierView?: boolean;
   onEditBalanceClick?: () => void;
   openAdmissionPalletsModal?: () => void;
   selectedDate: Date;
   handleDateChange: (date: Date) => void;
};

const RentedPalletsSummarySection = ({
   rentedPalletsSummaryData,
   isSupplierView,
   openAdmissionPalletsModal,
   onEditBalanceClick,
   selectedDate,
   handleDateChange,
}: RentedPalletsSummarySectionProps) => {
   const { t, i18n } = useTranslation();

   return (
      <SectionContainer
         title={t('rentedPalletsSummary.title')}
         subtitle={t('rentedPalletsSummary.subtitle')}
         headerRightSideElement={
            <div className={styles.headerRight}>
               <DatePicker
                  value={selectedDate}
                  inputFormat={DATE_PICKER_DATE_FORMAT}
                  icon={<OutlinedCalendarIcon />}
                  locale={i18n.language}
                  className={styles.datePicker}
                  clearable={false}
                  onChange={value => handleDateChange(value!)}
               />
               {isSupplierView ? (
                  <RentedPalletsSummarySectionActionsDropdown
                     onClickMovePallets={() => {
                        openAdmissionPalletsModal!();
                     }}
                     onClickEditPalletsBalance={() => onEditBalanceClick && onEditBalanceClick()}
                  />
               ) : undefined}
            </div>
         }
      >
         <div className={styles.container}>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('rentedPalletsSummary.edhp')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('EDHP_PALLET', rentedPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('damageLossPalletsSummary.euro')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('EURO_PALLET', rentedPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('rentedPalletsSummary.ndhp')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('HALF_PALLET_NDHP', rentedPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('rentedPalletsSummary.cdhp')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('QUARTER_PALLET_CDHP', rentedPalletsSummaryData)}
               </span>
            </span>
         </div>
      </SectionContainer>
   );
};

export default RentedPalletsSummarySection;
